export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14043.0cc8c906.jpg";